import React, { useState } from "react";

import { AnalyticsFilterProvider } from "../../context/AnalyticsFilterContext";

import PageTitle from "../../components/page-title";
// import ComingSoon from "../../components/coming-soon";

import AnalyticsTopbar from "./analytics-topbar";
import CampaignAnalytics from "./campaigns-analytics";
import CustomerAnalytics from "./customers-analytics";

const AnalyticsPage = () => {
  const [isCampaignAnalytics, setIsCampaignAnalytics] = useState(true);

  const switchTabContent = (value: boolean) => {
    setIsCampaignAnalytics(value);
  };

  return (
    <React.Fragment>
      <PageTitle title="Analytics" />
      {/* <ComingSoon name="Analytics" daysToCountdown={9.5} /> */}
      <AnalyticsTopbar onFilter={switchTabContent} />
      <AnalyticsFilterProvider>
        <div className="page_container analytics_page_container">
          {isCampaignAnalytics ? <CampaignAnalytics /> : <CustomerAnalytics />}
        </div>
      </AnalyticsFilterProvider>
    </React.Fragment>
  );
};

export default AnalyticsPage;
